import React, { useCallback, useEffect, useState } from 'react';
import { Alert, Badge, Button, Spinner } from 'react-bootstrap';
import axios from 'axios';

const cards = [
  ['started', 'Qualificações iniciadas', '#2563eb'],
  ['completed', 'Convertidas', '#16a34a'],
  ['conversion_rate', 'Taxa de conversão', '#7c3aed', '%'],
  ['active', 'Em andamento', '#0891b2'],
  ['handed_off', 'Encaminhadas', '#ea580c'],
  ['human_queue', 'Fila humana', '#dc2626'],
  ['unassigned', 'Sem atendente', '#be123c'],
  ['expired', 'Expiradas', '#64748b'],
];

export default function CommercialDashboard({ onOpenLead }) {
  const [days, setDays] = useState(30);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = useCallback(() => {
    setLoading(true);
    setError('');
    axios.get('/api/crm/dashboard', { params: { days } })
      .then(response => setData(response.data))
      .catch(requestError => setError(
        requestError.response?.data?.message || 'Não foi possível carregar o dashboard comercial.'
      ))
      .finally(() => setLoading(false));
  }, [days]);

  useEffect(load, [load]);

  if (loading && !data) {
    return <div className="text-center p-5"><Spinner animation="border" /></div>;
  }

  const summary = data?.summary || {};
  return (
    <div style={{ padding: 24, maxWidth: 1500, margin: '0 auto' }}>
      <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-4">
        <div>
          <h2 className="h5 mb-1">Visão comercial</h2>
          <div className="text-muted small">Conversão e atendimentos que exigem ação da equipe.</div>
        </div>
        <div className="d-flex gap-2">
          <select aria-label="Período do dashboard" className="form-select form-select-sm"
            value={days} onChange={event => setDays(Number(event.target.value))}>
            <option value={7}>Últimos 7 dias</option>
            <option value={30}>Últimos 30 dias</option>
            <option value={90}>Últimos 90 dias</option>
          </select>
          <Button size="sm" variant="outline-primary" onClick={load} disabled={loading}>
            Atualizar
          </Button>
        </div>
      </div>
      {error && <Alert variant="danger">{error}</Alert>}

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 12 }}>
        {cards.map(([key, label, color, suffix = '']) => (
          <div key={key} style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: 12, padding: 16 }}>
            <div className="text-muted small">{label}</div>
            <div style={{ color, fontSize: 26, fontWeight: 700 }}>{summary[key] ?? 0}{suffix}</div>
          </div>
        ))}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 16, marginTop: 16 }}>
        {[['Canais', data?.channels], ['Principais interesses', data?.interests]].map(([title, items]) => (
          <div key={title} style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: 12, padding: 16 }}>
            <strong>{title}</strong>
            {(items || []).length ? items.map(item => (
              <div key={item.label} className="d-flex justify-content-between border-bottom py-2 small">
                <span style={{ textTransform: title === 'Canais' ? 'capitalize' : 'none' }}>{item.label}</span>
                <strong>{item.total}</strong>
              </div>
            )) : <div className="text-muted small mt-3">Ainda não há dados no período.</div>}
          </div>
        ))}
      </div>

      <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: 12, marginTop: 16, overflow: 'hidden' }}>
        <div className="d-flex justify-content-between align-items-center p-3 border-bottom">
          <div><strong>Fila de atendimento humano</strong><div className="text-muted small">Ordenada por necessidade de atenção.</div></div>
          <Badge bg="danger">{(data?.queue || []).length}</Badge>
        </div>
        {(data?.queue || []).length === 0 ? (
          <div className="text-muted text-center p-4">Nenhum lead aguardando ação humana.</div>
        ) : (
          <div className="table-responsive">
            <table className="table table-hover align-middle mb-0">
              <thead><tr><th>Lead</th><th>Atenção</th><th>Canal</th><th>Atendente</th><th>Motivo / prazo</th><th /></tr></thead>
              <tbody>{data.queue.map(item => (
                <tr key={item.id}>
                  <td><strong>{item.name || `Lead #${item.id}`}</strong></td>
                  <td><Badge bg={item.attention === 'Encaminhado' ? 'danger' : 'warning'}>{item.attention}</Badge></td>
                  <td style={{ textTransform: 'capitalize' }}>{item.channel || '—'}</td>
                  <td>{item.responsible || <span className="text-danger">Sem atendente</span>}</td>
                  <td className="small">{item.reason || (item.task_due_at
                    ? `Vencimento: ${new Date(item.task_due_at).toLocaleString('pt-BR')}` : '—')}</td>
                  <td><Button size="sm" variant="outline-primary" onClick={() => onOpenLead(item)}>Abrir</Button></td>
                </tr>
              ))}</tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
